export const listBelt = (ctx: CanvasRenderingContext2D, leatherColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = leatherColor
  ctx.beginPath()
  ctx.moveTo(291, 488) // ベルト左上
  ctx.quadraticCurveTo(319, 538, 340, 588) // ベルト左下
  ctx.quadraticCurveTo(428, 599, 528, 586) // ベルト右下
  ctx.quadraticCurveTo(560, 508, 499, 434) // ベルト右上
  ctx.quadraticCurveTo(486, 476, 291, 488) // ベルト左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 手口ベルト縦＿外側
  ctx.moveTo(500, 441) // 上
  ctx.quadraticCurveTo(553, 513, 525, 584) // 折り返し左下_外
  // 手口ベルト縦＿内側
  ctx.moveTo(496, 448) // 上
  ctx.quadraticCurveTo(547, 511, 520, 587) // 折り返し左下_外
  ctx.stroke()
  ctx.setLineDash([])
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.closePath()
  // stitch
}

export const dWaveListBelt = (ctx: CanvasRenderingContext2D, leatherColor: string, hamidashiColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = leatherColor
  ctx.beginPath()
  ctx.moveTo(291, 488) // ベルト左上
  ctx.quadraticCurveTo(319, 538, 340, 588) // 左下_左
  ctx.quadraticCurveTo(362, 590, 362, 590) // 左下_右
  ctx.quadraticCurveTo(365, 559, 383, 552)
  ctx.quadraticCurveTo(490, 510, 515, 428)
  ctx.quadraticCurveTo(498, 434, 498, 434) // 右上、ヘリ革接触部分
  ctx.quadraticCurveTo(452, 470, 452, 470) //
  ctx.quadraticCurveTo(291, 488, 291, 488) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ハミダシ
  ctx.fillStyle = hamidashiColor
  ctx.beginPath()
  ctx.moveTo(509, 432) // 右上＿左
  ctx.quadraticCurveTo(492, 482, 447, 513) //
  ctx.quadraticCurveTo(399, 544, 375, 551) //
  ctx.quadraticCurveTo(357, 570, 358, 588)
  ctx.quadraticCurveTo(362, 590, 362, 590)
  ctx.quadraticCurveTo(365, 559, 383, 552)
  ctx.quadraticCurveTo(490, 510, 515, 428) // 右上＿右
  ctx.quadraticCurveTo(498, 434, 498, 434) // 右上、ヘリ革接触部分
  ctx.quadraticCurveTo(509, 432, 509, 432) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
